import React from "react";
import nextId from "react-id-generator";
import { Link } from "react-router-dom";
import SignUpComponent from "../../../Common/SignUpComponent/SignUpComponent";
import "./signing-up-page.style.scss";
export default function SigningUpPage() {
  const [mainType, setMainType] = React.useState(options[0]);
  return (
    <div className="signing-up-page-main">
      <p className="supm-top-line">
        Already have an account? <Link to={`/login/${mainType.id}`}>Login</Link>
      </p>
      <section className="supm-wrapper">
        <SignUpComponent setMainType={setMainType} />
      </section>
    </div>
  );
}

const options = [
  { keyId: nextId(), id: "candidate", text: "For Candidates" },
  { keyId: nextId(), id: "institution", text: "For Institutes" },
];
